import React from '../../vendor/react';
import { useState } from '../../vendor/react';
import { ArrowLeft, Mail } from '../../vendor/lucide-react';
import { Link } from '../../vendor/react-router-dom';
import { AuthLayout } from '../../components/auth/AuthLayout';
import { AuthNotice } from '../../components/auth/AuthNotice';
import { Button } from '../../components/ui/Button';
import { useAuth } from '../../features/auth/auth-store';
import { isEmail } from '../../features/auth/validation';

export function RecoveryPage() {
  const auth = useAuth();
  const [feedback, setFeedback] = useState('');
  const [error, setError] = useState('');
  const [localLink, setLocalLink] = useState('');

  const submit = async (event: SubmitEvent) => {
    event.preventDefault();
    setFeedback(''); setError(''); setLocalLink('');
    const email = String(new FormData(event.currentTarget as HTMLFormElement).get('email') ?? '');
    if (!isEmail(email)) return setError('Escribe un correo válido.');
    try {
      const result = await auth.actions.requestPasswordReset(email);
      setFeedback(result.message);
      if (result.token) setLocalLink(`/restablecer?token=${encodeURIComponent(result.token)}`);
    } catch (reason) {
      setError(reason instanceof Error ? reason.message : 'No se pudo preparar la recuperación.');
    }
  };

  return (
    <AuthLayout eyebrow="Recuperación" title="Recupera el acceso" description="Prepararemos un enlace seguro para cambiar la contraseña de tu cuenta.">
      {error && <AuthNotice tone="error">{error}</AuthNotice>}
      {feedback && <AuthNotice tone="success">{feedback}</AuthNotice>}
      {localLink && <Link className="local-action-link" to={localLink}>Abrir recuperación local</Link>}
      <form className="auth-form" onSubmit={submit}>
        <label className="auth-field"><span>Correo electrónico</span><div><Mail size={18} /><input name="email" type="email" autoComplete="email" placeholder="tu@negocio.com" required /></div></label>
        <Button type="submit" size="lg" className="full-width">Preparar recuperación</Button>
      </form>
      <p className="auth-card__footer"><Link to="/ingresar"><ArrowLeft size={14} /> Volver al acceso</Link></p>
    </AuthLayout>
  );
}
